import { useTranslations } from '@fshr/context/i18n-context';
import { IconSearch } from '../icon';
import { IconX } from '../icon';

const SearchBar = ({
	searchTerm,
	doSearch,
	clearSearch,
	onChange,
	isLoading,
	hasSearched,
}: {
	searchTerm: string;
	doSearch: () => void;
	clearSearch: () => void;
	onChange: (newSearchTerm: string) => void;
	isLoading: boolean;
	hasSearched: boolean;
}) => {
	const t = useTranslations();

	return (
		<div className="spacing-card-padding-y-xs lg:pt-0!">
			<div className="h-[60px] flex flex-row spacing-inline-xs px-150 py-[12px] bg-surface-form border border-border-subtle rounded-[4px]">
				<input
					id="search-term"
					placeholder={t('Search')}
					disabled={isLoading}
					value={searchTerm}
					autoComplete="off"
					onChange={event => {
						onChange(event.currentTarget.value ?? event.target.value);
					}}
					onKeyUp={event => {
						if (event.key === 'Enter') {
							event.preventDefault();
							doSearch();
						}
					}}
					className="peer border-black text-body2 text-text-heading focus:outline-hidden w-full placeholder:transition-opacity placeholder:opacity-100! placeholder:duration-300! placeholder:text-text-heading! focus:placeholder:opacity-0!"
				/>
				<button
					onClick={event => {
						event.preventDefault();
						if (hasSearched) {
							clearSearch();
						} else {
							doSearch();
						}
					}}
					className=""
				>
					{hasSearched ? (
						<IconX width={20} height={20} />
					) : (
						<IconSearch width={20} height={20} fill="#1F1F1F" />
					)}
				</button>
			</div>
		</div>
	);
};

export default SearchBar;
